import { formatFileSize } from '@/shared/utils/file.utils';
import { ActionIcon, Group, List, Text, Tooltip } from '@mantine/core';
import { IconFile, IconX } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

type SelectedFileItemProps = {
  file: File;
  onRemove: () => void;
};

const SelectedFileItem = ({ file, onRemove }: SelectedFileItemProps) => {
  const { t } = useTranslate();

  return (
    <List.Item>
      <Group gap="xs" wrap="nowrap" justify="space-between">
        <IconFile size={18} aria-hidden="true" />
        <Text size="sm" truncate style={{ flex: 1, minWidth: 0 }}>
          {file.name}
        </Text>
        <Text size="xs" c="dimmed" style={{ flexShrink: 0 }}>
          {formatFileSize(file.size)}
        </Text>
        <Tooltip label={t('file.submission.files.remove')} withArrow>
          <ActionIcon
            type="button"
            variant="subtle"
            color="red"
            aria-label={t('file.submission.files.remove')}
            onClick={onRemove}
          >
            <IconX size={16} />
          </ActionIcon>
        </Tooltip>
      </Group>
    </List.Item>
  );
};

export default SelectedFileItem;
